module.exports = __webpack_public_path__ + "static/media/grafismo-header-direito.62bf696c.svg";